import { api } from '../api';

export const paymentService = {
  async fetchPayments(params) {
    return api.get('payments', { params });
  },

  async fetchPayment(id) {
    return api.get('payments/' + id );
  },

  async requestPayment() {
    return api.post('payments/request');
  },
};